import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { closeNotification } from '../../store/actions/setting'
import { responseMessageT } from '../../store/middleware'
import { getNotificationModal } from '../../store/selectors/selectors'
import { ErrorModal } from '../Modals/ErrorModal/ErrorModal'
import { WrapModals } from '../WrapModals/WrapModals'

export const NotificationModal = () => {

    const notificationModal: responseMessageT | any = useSelector(getNotificationModal)
    const dispatch = useDispatch();


    let onClose = () => {
        if (!!notificationModal) {

            dispatch(closeNotification(notificationModal))
        }

    }

    return (
        <div>
            {
                notificationModal && <>
                    {notificationModal['error'] ? (<WrapModals>
                        <ErrorModal onClose={onClose} title={`We’re sorry,`} message={notificationModal['message']} isInfo={!notificationModal['error']} />
                    </WrapModals>) : <WrapModals>
                        <ErrorModal onClose={onClose} title={`Purchase Option`} message={notificationModal['message']} isInfo={notificationModal['error']} />
                    </WrapModals>}</>
            }



        </div>
    )
}
